import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import MultiFiltersPlugin from './plugins/multifilters/MultiFilters'
import VueExcelXlsx from "vue-excel-xlsx";
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueExcelXlsx)

Vue.config.productionTip = false

Vue.use(MultiFiltersPlugin);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
